export const STATUSCODE: Readonly<{ [key: string]: string }> = Object.freeze({
  NOT_QUALIFIED: "NOT_QUALIFIED",
  QUALIFIED: "QUALIFIED",
  TRACKING: "TRACKING",
  PENDING_ELIGIBLE: "PENDING_ELIGIBLE",
});
